import { IComponentOptions } from "angular";
import { SycuanMachinesComponentsViewsMainController } from "./controller";

export const vsComponentName = "machinesView";

export const SycuanMachinesComponentsViewsMain: IComponentOptions = {
  controller: SycuanMachinesComponentsViewsMainController,
  controllerAs: "machinesViewController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridConfiguration: "<",
    reportGroup: "<",
  },
};
